import React from 'react';

import CountryInfo from '../CountryInfo';

const LOAN_SECTION = {
    title: 'Zero Interest Loans for Small Businesses',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Details</p>
            <ul>
                <li>
                    500 billion yen in zero-interest loans for small and
                    midsized companies short of cash due to sharp falls in sales
                    (sales decline of at least 15 percent and 20 percent,
                    respectively. The financial support will also cover affected
                    individual business operators).
                </li>
                <li>
                    Companies and individuals whose sales dropped 5 to 14
                    percent can apply for loans with an interest rate of less
                    than 1 percent.
                </li>
                <li>
                    4,100 yen a day in subsidies for freelance workers who are
                    forced to give up work to take care of their children amid
                    school closures following the outbreak.
                </li>
                <li>
                    For major companies whose overseas business has taken a hit,
                    public financial institutions -- the Japan Bank for
                    International Cooperation and the Development Bank of Japan
                    -- will extend support.
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Abe unveils zero-interest loan scheme for small firms hit by virus',
            url: 'https://english.kyodonews.net/news/2020/03/9dd6b7242a45-abe-unveils-zero-interest-loan-scheme-for-small-firms-hit-by-virus.html',
        },
        {
            title: 'Japan Unveils Multibillion-Dollar Plan to Support Coronavirus-Hit Businesses',
            url: 'https://www.wsj.com/articles/japan-unveils-multibillion-dollar-plan-to-support-coronavirus-hit-businesses-11583841220',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Japan',
    lastUpdated: 'March 17, 2020',
    introSection: (
        <p>Japan has announced zero interest loans for small businesses.</p>
    ),
    sections: [LOAN_SECTION],
};

const JapanInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default JapanInfo;
